import { Injectable } from '@angular/core';
import { Subject } from '@node_modules/rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountNotificationService {

  private quantidadeNotificacoes: number;
  private quantidadeNotificacoesUpdated = new Subject<number>();

  getQuantidadeNotificacoes() {
    return this.quantidadeNotificacoes;
  }

  getQuantidadeNotificacoesUpdateListener() {
    return this.quantidadeNotificacoesUpdated.asObservable();
  }

  setQuantidadeNotificacoes(value: number) {
    this.quantidadeNotificacoes = value;
    this.quantidadeNotificacoesUpdated.next(this.quantidadeNotificacoes);
  }
}
